import React from 'react';
import AvansForm from './AvansForm';

class AvansPage extends React.Component {
  render() {
    return (
      <div>
        <AvansForm />
      </div>
    );
  }
}

export default AvansPage;



// WEBPACK FOOTER //
// ./src/components/avans/AvansPage.js